export enum EmailTemplateActionEnum {
    connDefault = 0,
    OnCreated,
    OnUpdated,
    OnDeleted,
    OnAssigned,
    OnUnassignedect
}

export const EmailTemplateActionTypes = [
    {
        id: EmailTemplateActionEnum.connDefault,
        name: 'Default'
    },
    {
        id: EmailTemplateActionEnum.OnCreated,
        name: 'On Created'
    },
    {
        id: EmailTemplateActionEnum.OnUpdated,
        name: 'On Updated'
    },
    {
        id: EmailTemplateActionEnum.OnDeleted,
        name: 'On Deleted'
    },
    {
        id: EmailTemplateActionEnum.OnAssigned,
        name: 'On Assigned'
    },
    {
        id: EmailTemplateActionEnum.OnUnassignedect,
        name: 'On Unassigned'
    },
];
